import { createContext } from 'react';
import { ProformaInvoiceDraft } from 'src/types/proformaInvoice';

export interface InvoiceDrawerContextValue {
  isOpen: boolean;
  mode: 'create' | 'update' | null;
  openCreateForm: (options?: {
    defaultValues?: Partial<ProformaInvoiceDraft>;
    onSuccess?: () => void;
  }) => void;
  openUpdateForm: (options: { uuid: string; onSuccess?: () => void }) => void;
  close: () => void;
}

const InvoiceDrawerContext = createContext<InvoiceDrawerContextValue>({
  isOpen: false,
  mode: null,
  openCreateForm: () => {},
  openUpdateForm: () => {},
  close: () => {},
});

export default InvoiceDrawerContext;
